import { all, takeEvery, call, put, select } from "redux-saga/effects";

import { createEntitySaga } from "./apiSagas.js";
import { createAction } from "../actions/actionUtils.js";
import { buildProjectCreationData } from "../reducers/projectWizard/projectWizardUtils.js";

import { ESTIMATES } from "../actions/actionConstants.js";

import { checkForDefaultSchedule } from "../reducers/schedules/scheduleUtils.js";
import { getProjectEstimate } from "../reducers/projectWizard/projectWizardActions.js";
import { operationAction } from "../reducers/operations/operationActions.js";
import { OPERATIONS } from "../../constants/operations.js";
import { operationSaga } from "./operationSagas.js";

// -- UPDATE SAGAS -- //

export function* getEstimatesSaga(action) {
  const { schedules, data, project } = action.payload;

  if (!schedules) return null;

  const state = yield select();

  const calls = schedules.map(scheduleId => {
    const schedule = checkForDefaultSchedule(scheduleId);
    const atId = data["@id"] || scheduleId;
    const values = buildProjectCreationData(state, data, atId, schedule);

    if (project) {
      const estimateOperationAction = operationAction(
        ESTIMATES,
        project,
        OPERATIONS.ESTIMATE,
        values,
        {
          autoComplete: false
        }
      );

      // return put(estimateOperationAction);
      return call(operationSaga, estimateOperationAction, true);
    } else {
      return put(getProjectEstimate(values, schedule));
    }
  });

  try {
    yield all(calls);
    yield put(createAction(ESTIMATES.POST_COMPLETE));
  } catch (error) {
    console.error("getEstimatesSaga: ERROR ::", error);
  }
}

export function* estimateSaga(action) {
  // disabled as reseting the estimates store will make the estimates panel jump around
  yield put(createAction(ESTIMATES.RESET));
  yield call(createEntitySaga, ESTIMATES, undefined, action);
  yield put(createAction(ESTIMATES.POST_COMPLETE));
}

// -- WATCHERS -- //

export function* watchEstimateSagas() {
  yield takeEvery(ESTIMATES.POST, estimateSaga);
}
